namespace Matrix.Rebalancer {
    export interface SortSettingsForm {
        Context: Serenity.StringEditor;
        Code: Serenity.StringEditor;
        SortId: Serenity.IntegerEditor;
        Version: StaticTextBlock;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
    }

    export class SortSettingsForm extends Serenity.PrefixedContext {
        static formKey = 'Rebalancer.SortSettings';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SortSettingsForm.init)  {
                SortSettingsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(SortSettingsForm, [
                    'Context', w0,
                    'Code', w0,
                    'SortId', w1,
                    'Version', w2,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3
                ]);
            }
        }
    }
}
